import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';

import { apiUrls } from '../../../config/api/api-urls.config';
import { ApiAdminUsersLoginResponse } from '../../../models/admin-users/responses/api-admin-users-login-response.model';
import { AdminUserResultsResponse } from '../../../models/admin-users/responses/api-admin-users-results-response.model';

@Injectable({
  providedIn: 'root'
})
export class ApiAdminUsersService {

  constructor(private apiService: ApiService) { }

  loginAdminUser(email: string | null, password : string): Promise<ApiAdminUsersLoginResponse> {
    return new Promise<ApiAdminUsersLoginResponse>((resolve, reject) => {
      const urlFull = `${apiUrls.adminUsersLoginUrl}`;
      const body = { email: email, password : password };

      this.apiService.launchAdminApiRequestPost(urlFull, body).then(
        (data: any) => {
            resolve(data);
        }, error => { reject(error); });
    });
  }

  addAdminUser(email: string, password: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const urlFull = `${apiUrls.adminUsersAddUrl}`;
      const body = { email: email, password: password };

      this.apiService.launchAdminApiRequestPost(urlFull, body).then(
        () => { resolve(); },
        error => { reject(error); });
    });
  }

  editAdminUser(userId: number, email: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const urlFull = `${apiUrls.adminUsersEditUrl}`;
      const body = { user_id: userId, email: email };

      this.apiService.launchAdminApiRequestPost(urlFull, body).then(
        () => { resolve(); },
        error => { reject(error); });
    });
  }

  editAdminUserPassword(userId: number, password: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const urlFull = `${apiUrls.adminUsersEditPasswordUrl}`;
      const body = { user_id: userId, password: password };

      this.apiService.launchAdminApiRequestPost(urlFull, body).then(
        () => { resolve(); },
        error => { reject(error); });
    });
  }

  deleteAdminUser(userId: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const urlFull = `${apiUrls.adminUsersDeleteUrl}`;
      const body = { user_id: userId };

      this.apiService.launchAdminApiRequestPost(urlFull, body).then(
        () => {
            resolve();
        }, error => { reject(error); });
    });
  }

  getAdminUsers(): Promise<AdminUserResultsResponse> {
    return new Promise<AdminUserResultsResponse>((resolve, reject) => {
      const urlFull = `${apiUrls.adminUsersGetUsersUrl}`;

      this.apiService.launchAdminApiRequestGet(urlFull, AdminUserResultsResponse).then(
        (data: AdminUserResultsResponse) => {
          resolve(data);
        }, error => { reject(error); });
    });
  }
}
